import React from "react";
import Layout from "../../components/Layout/Layout";
import "./Syndic.css";
import syndic from "../../assets/syndic.jpeg";

const Syndic: React.FC = () => {
    return (
        <Layout>
            <div className="syndicContainer">
                <h1 className="pageTitle">Syndic</h1>

                <div className="contentPaper">
                    <p className="contentText">
                        <span className="highlightBrand">AKTE IMMOBILIER</span> est spécialisé dans la gestion de copropriété,
                        de toutes tailles. Nous nous engageons à assurer une <b>gestion saine et transparente</b>
                        de votre immeuble, tout en garantissant son entretien courant et sa valorisation sur le long terme.
                    </p>

                    <p className="contentText">
                        Structure à taille humaine, vous n'aurez qu'un seul interlocuteur, vous permettant ainsi
                        d'avoir des réponses à l'ensemble de vos besoins.
                    </p>

                    <p className="sectionTitle"><b>Notre volonté :</b></p>
                    <p className="contentText">
                        Gérer votre immeuble en <b>collaboration étroite avec vous</b>.
                    </p>

                    <p className="sectionTitle"><b>Nos engagements :</b></p>
                    <ul className="engagementsList">
                        <li>Un interlocuteur unique</li>
                        <li>Une <b>gestion de proximité</b></li>
                        <li>Une comptabilité transparente</li>
                        <li>Un devoir de conseils sur tous les aspects de la copropriété (législation, obligations réglementaires, ...)</li>
                        <li>Un Espace client intuitif et alimenté régulièrement</li>
                        <li>Une facturation juste</li>
                    </ul>
                </div>
            </div>
        </Layout>
    );
};

export default Syndic;
